import FormularioIntercambio from '../../components/serviciointercambio/FormularioIntercambio';

const ServicioIntercambio = () => (
  <div>
    <div style={{ marginBottom: '16px' }}>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>SII</h1>
      <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
        Gestión del servicio de intercambio
      </p>
    </div>
    <FormularioIntercambio />
  </div>
);

export default ServicioIntercambio;
